var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"txt"},[_vm._v(_vm._s(_vm.$t('heel').tips))]),_c('TabBar',{attrs:{"active":"Heel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }